@if (permissions) {
    <span class="flex w-fit justify-between pl-1 sm:w-full">
        <div class="hidden w-auto items-center gap-2 text-list-row-action sm:flex">
            @if (permissions.showRead || permissions.showReadTrashCan) {
                <span class="actions-cell-button" kendoTooltip [title]="'Read' | translate">
                  <bizz-icon class="actions-cell-icon" (click)="onOpenClicked($event)" iconName="eye"></bizz-icon>
                </span>
            }
            @if (permissions.showEdit) {
                <span class="actions-cell-button" kendoTooltip [title]="'Edit' | translate">
                  <bizz-icon class="actions-cell-icon" (click)="onEditClicked($event)" iconName="pencil"></bizz-icon>
                </span>
            }
        </div>
        <span class="actions-cell-button text-list-row-action"
              id="actions-menu-icon-{{data.ID}}"
              (click)="onActionMenuIconClick($event)"
              [hidden]="!permissions.showDropdownMenu"
              #menuIcon>
              <bizz-icon class="actions-cell-menu-icon" iconName="ellipsis-vertical"></bizz-icon>
        </span>
    </span>
}
